import React, { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import { Layout } from "antd";
import { SideMenu } from "./components";
import "./AppLayout.css";
import currentUserActions from "../../_actions/user.actions";

const { Sider, Content } = Layout;
const AppLayout = ({ children }) => {
  const [collapsed, setCollapsed] = useState(true);
  const { fetchUserAndPermissions } = currentUserActions;

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(fetchUserAndPermissions());
  });

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <Layout className="page__layout night">
      <Sider
        breakpoint="lg"
        collapsedWidth={"65"}
        trigger={null}
        onClick={() => setCollapsed(false)}
        onCollapse={(collapsed, type) => {
          setCollapsed(collapsed);
        }}
        collapsible
        collapsed={collapsed}
        width={210}
        className="page__layout__sider night"
      >
        <SideMenu />
      </Sider>
      <Layout className="page__layout__main night" role={"main"}>
        <Content
          className="page__layout__content night"
          onClick={() => setCollapsed(true)}
        >
          {children}
        </Content>
      </Layout>
    </Layout>
  );
};

export default AppLayout;
